import { render, staticRenderFns } from "./UpdateVirtualAliasModal.vue?vue&type=template&id=3e6e254a&"
import script from "./UpdateVirtualAliasModal.vue?vue&type=script&lang=js&"
export * from "./UpdateVirtualAliasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports